import { CLEAR_NOTIFICATIONS, NEW_NOTIFICATION, SET_LATEST_NOTIFICATIONS } from "../../constants";

const initialState = {
  notificationsNumber: 0,
  data: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case NEW_NOTIFICATION:
      const data = state.data;
      let Badge = ++state.notificationsNumber;
      if (data.length >= 50) {
        data.pop();
      }
      if (Badge >= 50) {
        Badge = "+50";
      }
      return {
        ...state,
        data: [action.payload.alert, ...data],
        notificationsNumber: Badge,
      };
    case SET_LATEST_NOTIFICATIONS:
      return {
        ...state,
        data: action.payload.notifications.filter(
          (n) => n.params.id_entity === action.payload.idEntity
        ),
      };
    case CLEAR_NOTIFICATIONS:
      return {
        ...state,
        notificationsNumber: 0,
      };
    default:
      return state;
  }
};
